import "../styles/price.scss";
import check from "../assets/img/checkMark.png";

export default function PriceTable(props) {
    return (
        <div className="priceMain">
            {props.data.map((price, index) => (
                <div
                    key={index}
                    className={index != 1 ? "price-item" : "price-item p2"}
                >
                    <div className="price-date">{price.date}</div>
                    <div className="price-text">{price.text}</div>
                    {price.price.map((i) => {
                        return (
                            <div key={i} className="price-amount">
                                {i}
                            </div>
                        );
                    })}
                    <div className="price-time">{price.time}</div>
                    {price.data.map((item, idx) => {
                        return (
                            <div className="price-data">
                                <img src={check} />
                                <div>{item}</div>
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
}
